import * as React from 'react'
const SvgStuetzenDisabled = props => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.4981 18.0032C9.186 18.5673 6 20.5554 6 22.9215C6 25.7263 10.4772 28 16 28C21.5228 28 26 25.7263 26 22.9215C26 20.551 22.8019 18.5598 18.4774 18" stroke="#C4C6D2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M14 6V23C14 23.5523 14.8954 24 16 24C17.1046 24 18 23.5523 18 23V6" stroke="#C4C6D2"/>
    <ellipse cx="16" cy="6" rx="2" ry="1" stroke="#C4C6D2"/>
  </svg>
)

export default SvgStuetzenDisabled